import './Nav.css'

function Nav() {
    return(
        <header>
        <h1>Cappsule web development test</h1>
        </header>
    )
}

export default Nav